export function getLocalStorageItem(key) {
  const itemStr = localStorage.getItem(key);

  if (!itemStr) {
    return null;
  }
  let item;
  try {
    item = JSON.parse(itemStr);
  } catch {
    return null;
  }

  if (item.expiry && new Date().getTime() > item.expiry) {
    removeLocalStorageItem(key);
    return null;
  }

  return item.value;
}

export function setLocalStorageItem(key, value, expirationInMiliSecond = null) {
  const item = {
    value,
    expiry: expirationInMiliSecond
      ? new Date().getTime() + expirationInMiliSecond
      : null,
  };

  localStorage.setItem(key, JSON.stringify(item));
}
export function removeLocalStorageItem(key) {
  localStorage.removeItem(key);
}
